import React from 'react'
import { BulkUpdateContextType } from './BulkUpdateContext.type'

export const BulkUpdateContext = React.createContext<BulkUpdateContextType | null>(null)
